jQuery(document).ready(function(){

	adjustBannerHeight();

	$(window).resize(function(){
		adjustBannerHeight();
	})

	function adjustBannerHeight(){

		var header_height = $('.header').outerHeight();

		$('.banner').css('height', 'calc(100vh - '+header_height+'px)');

	}

});